<template>
<div>
  <div @click="toggle" v-if="collapsible" class="text-center dropdown-block" >
    <span v-if="collapsed">
      <i  class="el-icon-caret-top" /> <span style="display: table-cell; vertical-align: middle;">Hide related interaction</span>
    </span>

    <span v-else>
      <i  class="el-icon-caret-bottom" /> <span style="display: table-cell; vertical-align: middle;">View related interaction</span>
    </span>
  </div>
  <el-collapse-transition >
  <div class="feed-element" v-show="!collapsible || collapsed">
    <div class="interaction-avatar pull-left">
      <img :src="interaction.ore.profile_image[0].value" @error="imageLoadOnError()" class="img-circle" v-if="interaction.ore.profile_image">
      <i class="fa fa-user-circle fa-3x" v-else></i>
      <div class="interaction-type img-circle" :class="interaction.type">
        <i class="fa fa-sm" :class="iconClasses[interaction.type]"></i>
      </div>
    </div>
    <div class="media-body">
      <small class="text-muted pull-right interaction-date">{{ interaction.date_created | moment('HH:MM Do MMM YYYY ') }}</small>
      <div class="interaction-originator">{{ interaction.ore.originators[0].value }}</div>
      <div class="interaction-media" v-if="mediaExists">
        <img v-if="interaction.ore.image" class="img-responsive" :src="getMediaValue(interaction, 'image')" />
        <video v-if="interaction.ore.video" :src="getMediaValue(interaction, 'video')" controls></video>
        <audio v-if="interaction.ore.audio" :src="getMediaValue(interaction, 'audio')" controls></audio>
      </div>
      <div class="interaction-message">{{ interaction.ore.message[0].value }}</div>
    </div>
  </div>
  </el-collapse-transition>
</div>
</template>

<script>
export default {
  name: 'ParentInteraction',
  props: {
    interaction: {
      type: Object,
      required: true,
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    iconClasses: {
      facebook_post: 'fa-facebook',
      facebook_comment: 'fa-facebook',
      facebook_message: 'fa-facebook',
      twitter: 'fa-twitter',
      tweet: 'fa-twitter',
      instagram: 'fa-instagram',
      message: 'fa-mobile',
      sms: 'fa-mobile',
      whatsapp: 'fa-whatsapp',
      email: 'fa-envelope-o',
      titkok: 'fa-play-circle-o',
    },
  }),
  computed: {
    mediaExists() {
      return this.interaction.ore.image || this.interaction.ore.video || this.interaction.ore.audio;
    },
  },
  methods: {
    getMediaValue(interaction, mediaType) {
      /* eslint no-prototype-builtins :off */
      if (
        interaction.ore.hasOwnProperty(mediaType) &&
        interaction.ore[mediaType] &&
        interaction.ore[mediaType].length &&
        interaction.ore[mediaType][0].hasOwnProperty('value')
      ) {
        return interaction.ore[mediaType][0].value;
      }
      return '';
    },
    imageLoadOnError() {
      this.interaction.ore.profile_image[0].value =
        '/static/assets/icons/user/default_profile_normal.png';
    },
    toggle() {
      this.collapsed = !this.collapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/style/_variables_live.scss';

.feed-element {
  padding: 0px 0;
}

.interaction-avatar {
  margin-right: 12px;
  color: $silver;
}

.facebook_message,
.facebook_post {
  background-color: $chambray;
}

.message,
.sms {
  background-color: $curious-blue;
}

.whatsapp {
  background-color: $emerald;
}

.email {
  background-color: $carnation;
}

.twitter,
.tweet {
  background-color: $dodger-blue;
}

.instagram {
  background-color: $royal-purple;
}

.interaction-date {
  font-size: 9px;
}

.interaction-type {
  position: relative;
  width: 20px;
  height: 20px;
  color: $white-solid;
  top: -14px;
  left: 25px;
  font-size: 1.45rem;
  text-align: center;
}

.interaction-originator {
  font-weight: bold;
}

.interaction-tools {
  margin-top: 4px;

  a {
    padding-right: 3px;
    color: $mystic;
  }

  a.onair:hover {
    color: $radical-red;
  }

  a.reply:hover {
    color: $dodger-blue;
  }

  a.comment:hover {
    color: $jungle-green;
  }
}

.interaction-media {
  padding-top: 15px;
  padding-bottom: 15px;
}

.dropdown-block {
    width: 100%;
    border-top: 1px solid #eaeefb;
    height: 30px;
    padding-top: 10px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: 20px;
    color: #d3dce6;
    cursor: pointer;
    position: relative;

    i {
      font-size: 2.0em;
    }
}

i.dropdown-block:hover {
  color: #409eff;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// ParentInteraction.vue?61933f92